import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect, useRef } from 'react';
import { AppBar, Box, Container, Grid, Tabs, TAGLink, TAGTypography, useMediaQuery } from '../../';
import TAGNavListItem from '../elements/TAGNavigation/TAGNavListItem';

var NavLink = function NavLink(props) {
  return React.createElement(Grid, {
    item: true,
    sx: {
      mr: {
        xs: '8px',
        md: '24px'
      },
      '.MuiListItem-root': {
        p: {
          xs: '6px 12px',
          md: 0
        },
        backgroundColor: {
          xs: 'backgrounds.neutral',
          md: 'transparent'
        },
        borderRadius: {
          xs: '18px',
          md: 0
        },
        '&:hover': {
          backgroundColor: {
            xs: 'backgrounds.neutral',
            md: 'transparent'
          },
          borderRadius: {
            xs: '18px',
            md: 0
          }
        },

        /* prevent clicking on active link */
        pointerEvents: props.activeLink == props.path ? 'none' : 'auto'
      },
      '.MuiListItemText-root': {
        margin: 0,
        '&:hover': {
          textDecoration: props.activeLink == props.path ? {
            xs: 'none',
            md: 'none'
          } : {
            xs: 'none',
            md: 'underline'
          }
        }
      },
      '.MuiTypography-root': {
        fontWeight: {
          xs: 700,
          md: 'inherit'
        },
        fontSize: {
          xs: '14px',
          md: 'inherit'
        },
        color: props.activeLink == props.path ? {
          xs: 'text.tertiary',
          md: 'text.tertiary'
        } : {
          xs: 'text.link',
          md: 'text.primary'
        }
      }
    }
  }, React.createElement(TAGLink, {
    href: props.path
  }, React.createElement(TAGNavListItem, {
    primaryText: props.breadcrumbTitle
  })));
};

var TertiaryNavigation = function TertiaryNavigation(_ref) {
  var activeLink = _ref.activeLink,
      links = _ref.links,
      title = _ref.title;

  /* media breakpoint */
  var isLargeDevice = useMediaQuery('(min-width: 768px)');
  /* set top value for sticky position */

  var marketingApp = isLargeDevice ? '128px' : '104px';
  /* show/hide Naviagation on scroll only for mobile resolutions */

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      lastScrollY = _useState4[0],
      setLastScrollY = _useState4[1];

  var controlNavbar = function controlNavbar() {
    if (typeof window !== 'undefined') {
      if (window.scrollY > lastScrollY) {
        // if scroll down hide the navbar
        setShow(false);
      } else {
        // if scroll up show the navbar
        setShow(true);
      } // remember current page location to use in the next move


      setLastScrollY(window.scrollY);
    }
  };

  useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlNavbar); // cleanup function

      return function () {
        window.removeEventListener('scroll', controlNavbar);
      };
    }
  }, [lastScrollY]);
  /* add shadow on sticky position */

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      shadow = _useState6[0],
      setShadow = _useState6[1];

  var navWrapperRef = useRef(null);
  var formTop = isLargeDevice ? 128 : 104;

  function shdw() {
    if (window.scrollY >= formTop) {
      setShadow(true);
    } else {
      setShadow(false);
    }
  }

  useEffect(function () {
    window.addEventListener('scroll', shdw);
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(AppBar, {
    position: "sticky",
    color: "inherit",
    style: {
      top: isLargeDevice ? marketingApp : show ? marketingApp : '-150px',
      backgroundColor: 'backgrounds.white',
      boxShadow: shadow ? '0 1px 2px rgba(0,0,0,.25)' : 'none',
      transition: 'all .3s ease',
      zIndex: 1
    },
    ref: navWrapperRef
  }, React.createElement(Grid, {
    sx: {
      backgroundColor: 'backgrounds.white',
      padding: {
        xs: '16px 0',
        md: '8px 0'
      }
    }
  }, React.createElement(Container, {
    sx: {
      pr: '0px'
    }
  }, React.createElement(Grid, {
    item: true,
    columnSpacing: 3
  }, React.createElement(TAGTypography, {
    variant: "h3",
    color: "text.primary",
    sx: {
      marginBottom: {
        xs: '16px',
        sm: '12px'
      }
    }
  }, title)), React.createElement(Box, {
    sx: {
      maxWidth: {
        xs: '100%'
      },
      bgcolor: 'backgrounds.white'
    }
  }, React.createElement(Tabs, {
    value: false,
    variant: "scrollable",
    scrollButtons: false,
    sx: {
      minHeight: 'auto'
    }
  }, links.navigationLinksForGroup.map(function (navLink, index) {
    var _activeLink$path;

    return React.createElement(NavLink, _objectSpread(_objectSpread({}, navLink), {}, {
      activeLink: (_activeLink$path = activeLink === null || activeLink === void 0 ? void 0 : activeLink.path) !== null && _activeLink$path !== void 0 ? _activeLink$path : '',
      key: index
    }));
  })))))));
};

export default TertiaryNavigation;